import type { NamespaceSchema } from './types';

export const advancedSettings: NamespaceSchema = {
  namespace: 'advanced-settings',
  label: 'Advanced',
  description: 'Map providers, search behaviour, cookie banner, performance toggles. Touch with care.',
  sections: [
    {
      label: 'Map provider',
      description: 'API keys live in env (NEXT_PUBLIC_GOOGLE_MAPS_API_KEY etc.) — set those at deploy time, not here.',
      fields: [
        { kind: 'select', key: 'map_provider', label: 'Map provider', default: 'google', options: [
          { value: 'google', label: 'Google Maps' },
          { value: 'mapbox', label: 'Mapbox' },
          { value: 'osm', label: 'OpenStreetMap (no key required)' },
        ] },
      ],
    },
    {
      label: 'Search defaults',
      fields: [
        { kind: 'select', key: 'search_open_tab', label: 'Default search tab', default: 'cars', options: [
          { value: 'cars', label: 'Cars' },
          { value: 'airports', label: 'Airports' },
          { value: 'cities', label: 'Cities' },
        ] },
        { kind: 'select', key: 'search_size_unit', label: 'Distance unit', default: 'km', options: [
          { value: 'km', label: 'Kilometres' },
          { value: 'mi', label: 'Miles' },
        ] },
      ],
    },
    {
      label: 'Cookie agreement',
      fields: [
        { kind: 'boolean', key: 'cookie_agreement_enabled', label: 'Show cookie banner', default: true },
        { kind: 'select', key: 'cookie_agreement_style', label: 'Banner style', default: 'banner', options: [
          { value: 'banner', label: 'Bottom banner' },
          { value: 'popup', label: 'Modal popup' },
          { value: 'corner', label: 'Bottom-corner card' },
        ] },
        { kind: 'textarea', key: 'cookie_agreement_message', label: 'Cookie banner message', rows: 3 },
        { kind: 'select', key: 'cookie_agreement_primary_button_role', label: 'Primary button role', default: 'accept', options: [
          { value: 'accept', label: 'Accept all' },
          { value: 'reject', label: 'Reject all' },
          { value: 'manage', label: 'Manage preferences' },
        ] },
        { kind: 'select', key: 'cookie_agreement_secondary_button_role', label: 'Secondary button role', default: 'manage', options: [
          { value: 'accept', label: 'Accept all' },
          { value: 'reject', label: 'Reject all' },
          { value: 'manage', label: 'Manage preferences' },
        ] },
      ],
    },
    {
      label: 'Performance',
      fields: [
        { kind: 'boolean', key: 'enable_isr', label: 'ISR enabled on storefront', default: true, description: 'Off forces dynamic rendering — only flip if you suspect cache-staleness.' },
        { kind: 'number', key: 'isr_revalidate_seconds', label: 'ISR revalidate (seconds)', default: 60, min: 0, max: 86400 },
      ],
    },
  ],
};
